import { WebEventNames } from './eventNames'
import { getEventTracker } from '@libs/eventTracking'
import {
  getCurrentPagePropertyFor,
  getNextPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'

/**
 * [Link to spec](https://www.dropbox.com/scl/fi/0yjttrmbnp3rqp2ug5h63/%E3%80%90%E6%95%B8%E6%93%9A%E3%80%91Web-%E6%90%9C%E5%B0%8B%E9%A0%81.paper?dl=0&rlkey=erjgvozrnl847ked5ohf5a8w7)
 */

export const getFilterVale = (value: string) => {
  switch (value) {
    case 'ALL':
      return 'all'
    case 'PGC':
      return 'official'
    case 'UGC':
      return 'creator'
    case 'HOT':
      return 'mostPopular'
    case 'LATEST':
      return 'newest'
    case 'RELEVANT':
      return 'mostMatches'
  }
}

export function trackSearchSortSwitchEvent(
  currentPageUrl,
  toPageUrl,
  currentKeyword,
  type,
  sort,
  toSort,
) {
  getEventTracker().track({
    name: WebEventNames.WEB_SEARCH_SORT_SWITCH,
    properties: {
      currentPage: getCurrentPagePropertyFor('web-search', currentPageUrl),
      toPage: getNextPagePropertyFor({ pageName: 'web-search', pageUrl: toPageUrl }),
      currentKeyword,
      typeFilter: getFilterVale(type),
      sortFilter: getFilterVale(sort),
      toSortFilter: getFilterVale(toSort),
    },
  })
}
